import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import type { ApiRole } from '@/js/services/api/role/types';

type SortableField = 'name';

export type RolesTableColumn =
    | { field: SortableField; name: string; sortable: true }
    | { field: 'actions'; name: string; sortable: false };

export type RolesTableItem = {
    id: string;
    name: string;
};

export function mapApiRole(role: ApiRole): RolesTableItem {
    return {
        id: role.id,
        name: role.name,
    };
}

export const useRolesTableData = defineStore('rolesTableData', () => {
    const roles = ref<RolesTableItem[]>([]);

    const search = ref('');
    const sortBy = ref<SortableField>('name');
    const sortDirection = ref<'asc' | 'desc'>('asc');
    const tableData = computed(() => {
        let result = [...roles.value];

        if (search.value) {
            const term = search.value.toLowerCase();
            result = result.filter((r) => r.name.toLowerCase().includes(term));
        }

        result.sort((a, b) => {
            if (a[sortBy.value] < b[sortBy.value]) return sortDirection.value === 'asc' ? -1 : 1;
            if (a[sortBy.value] > b[sortBy.value]) return sortDirection.value === 'asc' ? 1 : -1;
            return 0;
        });

        return result;
    });

    function setSort(field: typeof sortBy.value, order: 'asc' | 'desc') {
        sortBy.value = field;
        sortDirection.value = order;
    }

    return {
        roles,
        search,
        sortBy,
        sortDirection,
        setSort,
        tableData,
    };
});
